var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8399 9.82843C18.2778 11.3905 15.7452 11.3905 14.1831 9.82843C12.621 8.26633 12.621 5.73367 14.1831 4.17157C15.23 3.12466 16.7129 2.77938 18.0473 3.13575L15.5266 5.65651L14.8195 6.36362L17.6479 9.19204L18.355 8.48494L20.8758 5.96418C21.2321 7.29865 20.8869 8.78151 19.8399 9.82843ZM19.0437 3.55357L19.7692 2.82808C17.8278 1.54188 15.1864 1.754 13.476 3.46447C12.04 4.90046 11.66 6.99261 12.3362 8.77581L2.58579 18.5262C1.80474 19.3072 1.80474 20.5736 2.58579 21.3546C3.36684 22.1357 4.63317 22.1357 5.41422 21.3546L15.1335 11.6353C16.9385 12.3656 19.0835 11.999 20.547 10.5355C22.2575 8.82507 22.4696 6.18366 21.1834 4.2423L20.4579 4.96779L17.6479 7.77783L16.2337 6.36362L19.0437 3.55357ZM14.2112 11.1434C13.952 10.9678 13.7056 10.7652 13.476 10.5355C13.2212 10.2808 12.9997 10.0054 12.8114 9.71474L3.29289 19.2333C2.90237 19.6238 2.90237 20.257 3.29289 20.6475C3.68342 21.038 4.31658 21.038 4.70711 20.6475L14.2112 11.1434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.b71dd05cce462d0306890572f25028bf.svg";
export { ForwardRef as ReactComponent };